import { TaskStatuses } from '~/constants/task-status'
import { useTerminatedStatus } from '~/hooks/task/useTerminatedStatus'
import { AgentTaskStatus, agentTaskStatusToJSON } from '~/protos/agents'
import { cm } from '~/utils/utils'
import { getStatusText } from './TaskBlock'
import styles from './TaskProgress.module.scss'

interface TaskProgressBarProps {
  percentage: number
  taskStatus: AgentTaskStatus
  statusText?: boolean
}
export function TaskProgressBar({
  percentage,
  taskStatus,
  statusText = false
}: TaskProgressBarProps) {
  const status = TaskStatuses[taskStatus]
  const isTerminatedStatus = useTerminatedStatus(status.id)

  let statusColor = status.color
  if (isTerminatedStatus) {
    statusColor = TaskStatuses[AgentTaskStatus.COMPLETED].color
  }

  return (
    <div className='flex justify-between items-center my-1 w-full'>
      <div
        className={cm(
          `task-progress w-full h-[4px]`,
          'overflow-hidden rounded-full',
          styles.progress
        )}
        style={
          {
            '--bg-color': statusColor,
            '--percentage': `${percentage}%`
          } as React.CSSProperties
        }
      ></div>
      <div className='text-default-500 text-xs ml-2 flex flex-nowrap max-w-[40px]'>
        {percentage.toFixed(0)}%{' '}
        {statusText ? getStatusText(agentTaskStatusToJSON(taskStatus)) : ''}
      </div>
    </div>
  )
}
